<template>
  <div>
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class="active bold">
          Estadísticas
        </li>
      </template>
      <template slot="title">
        Indicadores Trimestrales.
      </template>
      <template slot="body">
        <RC17Numbers />
      </template>
    </GenericPage>
    <RC17LightBanner />
  </div>
</template>

<script>
import RC17Numbers from "@components/report-cuitf17-page/RC17Numbers";
import RC17LightBanner from "@components/report-cuitf17-page/RC17LightBanner";

import GenericPage from "./new-portal-views/GenericPage.vue";

require('@/assets/res/components/report-cuitf17.css');

export default {
  name: "ReportCuitf17Page",
  components: {
    RC17LightBanner,
    RC17Numbers,
    GenericPage
}
}
</script>

<style scoped>
</style>